import { useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';

export const EntryContainer = ({ className, children, col, showBorder }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <td
      className={`${className} ${col.className} align-top ${
        col.hideOnMobile ? 'hidden md:table-cell' : ''
      }`}
      style={{
        width: col.width ? col.width : 'max-content',
        maxWidth: col.width ? col.width : 'unset',
        textAlign: col.align ? col.align : 'left',
        padding: '5px 5px',
        borderLeft: showBorder ? '1px dashed darkgrey' : '',
      }}
    >
      {children}
    </td>
  );
};
